import React, { useState } from 'react';
import { UploadedAttachmentPreviewCard } from '@zg-rentals/satellite-components';
import { ModalType } from '../../../../types/ModalType';
import type { AttachmentsForMessage } from '../../../MessageAttachments';
import StringConstants from '../../../../constants/StringConstants';
import useModal from '../../../../hooks/useModal';
import type { AttachmentsUploadedForAddMessage } from '../../../AttachmentsUploader';
import ImagesViewer from '../../../ImagesViewer';
import { StyledLinearGradient, StyledUploadedAttachmentCards, StyledUploadedWrapper } from './StyledComponents';

type Props = {
  handleRemoveUploadedAttachment(zDocId: string): void;
  uploadedAttachments: AttachmentsUploadedForAddMessage;
};

const UploadedAttachmentPreviewCards = ({ handleRemoveUploadedAttachment, uploadedAttachments }: Props) => {
  const { activeModal, setActiveModal } = useModal();

  const [selectedImageAttachmentIndex, setSelectedImageAttachmentIndex] = useState(0);
  const imageAttachmentsForViewer: AttachmentsForMessage = [];

  const handleViewImageAttachment = (zDocId: string) => {
    const indexOfImageSelected = imageAttachmentsForViewer.findIndex(
      (imageAttachment) => imageAttachment.zDocId === zDocId,
    );

    setSelectedImageAttachmentIndex(indexOfImageSelected);
    setActiveModal(ModalType.ImagesViewer);
  };

  return (
    <>
      {activeModal === ModalType.ImagesViewer && (
        <ImagesViewer imageAttachments={imageAttachmentsForViewer} selectedImageIndex={selectedImageAttachmentIndex} />
      )}

      <StyledUploadedWrapper>
        <StyledUploadedAttachmentCards display="flex" flexDirection="column">
          {uploadedAttachments.map((uploadedAttachment) => {
            const { file, generatedPreviewUrl, zDocId } = uploadedAttachment;
            const { name, size, type } = file;
            const isImageFileType = type.includes(StringConstants.ATTACHMENTS.IMAGE_FILE_TYPE);
            const key = `${name}-${zDocId}`;

            if (isImageFileType) {
              const imageAttachmentForViewer = {
                fileName: name,
                fileSizeBytes: size,
                isAttachmentExpired: false,
                previewUrl: generatedPreviewUrl,
                zDocId: zDocId || name,
              };

              imageAttachmentsForViewer.push(imageAttachmentForViewer);
            }

            return (
              <UploadedAttachmentPreviewCard
                fileName={name}
                fileType={type}
                imageSrc={generatedPreviewUrl || ''}
                key={key}
                onClick={handleViewImageAttachment}
                onRemove={handleRemoveUploadedAttachment}
                zDocId={zDocId || ''}
              />
            );
          })}
        </StyledUploadedAttachmentCards>

        <StyledLinearGradient />
      </StyledUploadedWrapper>
    </>
  );
};

export default React.memo(UploadedAttachmentPreviewCards);
